import React from "react";

const stats = [
  { k: "01", label: "Reclaimed Steel", value: "100%" },
  { k: "02", label: "Builds Per Year", value: "≤ 12" },
  { k: "03", label: "Shop Hours / Build", value: "180+" },
  { k: "04", label: "Years In The Fire", value: "14" },
];

export default function Story() {
  return (
    <section
      id="story"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
      data-testid="story-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="flex items-center gap-4 mb-12">
          <span className="font-body text-[10px] tracking-[0.45em] uppercase text-[#FF7A00]">
            /02 — The Shop
          </span>
          <div className="h-px flex-1 bg-zinc-900" />
          <span className="font-body text-[10px] tracking-[0.45em] uppercase text-zinc-500">
            Cocoa, Florida
          </span>
        </div>

        <div className="max-w-4xl">
          <h2
            className="font-heading uppercase leading-[0.9] tracking-tight text-5xl md:text-6xl lg:text-7xl steel-text"
            data-testid="story-heading"
          >
            Recycled Materials
            <br />
            Turned Into Fully
            <br />
            Functional Art.
          </h2>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 text-zinc-400 text-base md:text-lg leading-relaxed">
            <p data-testid="story-paragraph-1">
              Emberline Fabrication is a one-man, one-fire workshop tucked
              inside a warehouse in Cocoa, Florida. We pull weathered propane
              tanks, decommissioned pipeline, and forgotten plate steel from
              scrap yards and worksites — then re-engineer them into smokers
              and firecraft built to outlast their makers.
            </p>
            <p data-testid="story-paragraph-2">
              No production lines. No catalog. Every commission is a
              conversation, a sketch, a cut. Heavy gauge. Thick welds.
              Cinematic geometry. The kind of fire machine you pass down, not
              replace.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-zinc-900 pt-8">
          {stats.map((s) => (
            <div key={s.k} data-testid={`story-stat-${s.k}`}>
              <div className="font-body text-[10px] tracking-[0.45em] uppercase text-zinc-600">
                {s.k}
              </div>
              <div className="mt-2 font-heading text-4xl md:text-5xl text-zinc-100">
                {s.value}
              </div>
              <div className="mt-1 font-body text-xs uppercase tracking-[0.2em] text-zinc-500">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
